import React from 'react'
import styles from './Input.module.scss'
import InputBase from '@mui/material/InputBase'
import cl from 'classnames'

export const Input = React.forwardRef(
	(
		{ prefix, postfix, placeholder, value, onChange, onKeyDown, containerClassName, inputClassName, onPostfixClick },
		ref
	) => {
		return (
			<div className={cl(styles.search__field, containerClassName)}>
				{prefix && (
					<div aria-label="prefix" className={cl(styles.search__icon, 'ps-2', 'pt-2', 'pb-2')}>
						{prefix}
					</div>
				)}
				<InputBase
					ref={ref}
					fullWidth
					placeholder={placeholder}
					inputProps={{ 'aria-label': 'search' }}
					value={value}
					onChange={onChange}
					onKeyDown={onKeyDown}
					className={cl('p-2', inputClassName)}
				/>
				{postfix && (
					<div
						aria-label="postfix"
						className={cl(styles.search__icon, 'pe-2', 'pt-2', 'pb-2')}
						onClick={(e) => onPostfixClick && onPostfixClick(e)}
					>
						{postfix}
					</div>
				)}
			</div>
		)
	}
)
